import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-4xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appData.desc}
            </p>

            <ul className="space-y-2 mb-8">
              {appData.features.map((feat, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <span className="w-5 h-5 flex items-center justify-center bg-primary-100 text-primary-500 rounded-full flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {feat}
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors cursor-pointer text-center"
              >
                <i className="ri-download-line mr-2"></i>
                下载APP
              </a>
              <a
                href="#features"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 text-sm font-medium text-foreground-700 bg-background-100 hover:bg-background-200 rounded-full transition-colors cursor-pointer text-center"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-56 h-[420px] md:w-64 md:h-[480px] bg-background-200 rounded-3xl overflow-hidden border-4 border-background-300">
              <div className="w-full h-full bg-gradient-to-b from-primary-500/20 to-accent-500/20 flex items-center justify-center">
                <div className="text-center px-4">
                  <span className="w-16 h-16 flex items-center justify-center bg-background-50/90 rounded-2xl mx-auto mb-4">
                    <i className="ri-smartphone-line text-2xl text-primary-500"></i>
                  </span>
                  <div className="text-sm font-semibold text-foreground-800">91免费在线视频</div>
                  <div className="text-xs text-foreground-500 mt-1">移动端APP</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}